import { useCallback, useRef } from "react";
import { useAccountQuery } from "../../../api/features/account/use-account.query";
import { useUserSubscriptionTierQuery } from "../../../api/features/user-subscription/useUserSubscriptionTier.query";
import { resolveUserTierAtEvent } from "../../../lib/mixpanel/resolve-user-tier-at-event";
import { trackChatbotPanelOpened } from "../../../lib/mixpanel/track-chatbot-panel-opened";
import type { ClaraEntryPoint } from "../constants/clara-entry-point.enum";
import type { IUseTrackChatbotPanelOpened } from "./useTrackChatbotPanelOpened.interface";

export function useTrackChatbotPanelOpened(): IUseTrackChatbotPanelOpened {
  const { accountData } = useAccountQuery();
  const { currentUserTier, isLoading: isUserTierLoading, error: userTierError } = useUserSubscriptionTierQuery();

  const eventContextRef = useRef({ accountData, currentUserTier, isUserTierLoading, userTierError });
  eventContextRef.current = { accountData, currentUserTier, isUserTierLoading, userTierError };

  const trackPanelOpened = useCallback(function trackPanelOpened(entryPoint: ClaraEntryPoint | undefined): void {
    const eventContext = eventContextRef.current;
    const isUserTierUnknown = eventContext.isUserTierLoading || Boolean(eventContext.userTierError);
    const userTierAtEvent = isUserTierUnknown ? undefined : resolveUserTierAtEvent(eventContext.currentUserTier);

    trackChatbotPanelOpened({
      accountId: eventContext.accountData?.id,
      userTierAtEvent,
      entryPoint,
    });
  }, []);

  return { trackPanelOpened };
}
